<template>
  <div>
    <div class="iframeBox">
      <iframe
        :src="iframeUrl"
        frameborder="0"
        height="100%"
        width="100%"
        id="iframe"
        v-show="!iframeLoading"
      ></iframe>
    </div>
    <Spin size="large" fix v-if="iframeLoading"> </Spin>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      iframeLoading: true,
      iframeUrl: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let obj = {
        appId: "6",
        userName: "admin",
        pageId: this.$route.params.page_id,
        groupId: this.$route.params.group_id,
        menuId: sessionStorage.getItem("menuId")
      };
      axios.post("/ELN/login", obj).then(res => {
        this.iframeLoading = false;
        this.iframeUrl = `http://47.106.214.90:1039/#/applicationLogin?nolayout=1&userName=${obj.userName}&appId=${obj.appId}&sign=${res.sign}&redirect=${res.redirect}`;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.iframeBox {
  height: calc(100vh - 200px);
}
</style>



// WEBPACK FOOTER //
// src/components/index/TrainManageInfo.vue